import {
  _UByte___init__impl__g9hnc418b8pq346rvu4 as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qrfg5oujomrowy as _UByte___get_data__impl__jof9qr,
  UBytep4j7r1t64gz1 as UByte,
} from './UByte.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from './exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { contains1a3ax1gghv0nr as contains } from './collections/_Arrays.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from './js/typeCheckUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _UByteArray___init__impl__ip4y9n(storage) {
  return storage;
}
function _UByteArray___get_storage__impl__d4kctt($this) {
  return $this;
}
function _UByteArray___init__impl__ip4y9n_0(size) {
  return _UByteArray___init__impl__ip4y9n(new Int8Array(size));
}
function UByteArray__get_impl_t5f3hv($this, index) {
  // Inline function 'kotlin.toUByte' call
  var this_0 = _UByteArray___get_storage__impl__d4kctt($this)[index];
  return _UByte___init__impl__g9hnc4(this_0);
}
function UByteArray__set_impl_jvcicn($this, index, value) {
  var tmp = _UByteArray___get_storage__impl__d4kctt($this);
  // Inline function 'kotlin.UByte.toByte' call
  tmp[index] = _UByte___get_data__impl__jof9qr(value);
}
function _UByteArray___get_size__impl__h6pkdv($this) {
  return _UByteArray___get_storage__impl__d4kctt($this).length;
}
function UByteArray__iterator_impl_509y1p($this) {
  return new (Iterator())(_UByteArray___get_storage__impl__d4kctt($this));
}
var IteratorClass;
function Iterator() {
  if (IteratorClass === VOID) {
    class $ {
      constructor(array) {
        this.bu_1 = array;
        this.cu_1 = 0;
      }
      v1() {
        return this.cu_1 < this.bu_1.length;
      }
      du() {
        var tmp;
        if (this.cu_1 < this.bu_1.length) {
          var _unary__edvuaz = this.cu_1;
          this.cu_1 = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.toUByte' call
          var this_0 = this.bu_1[_unary__edvuaz];
          tmp = _UByte___init__impl__g9hnc4(this_0);
        } else {
          throw NoSuchElementException().f2(this.cu_1.toString());
        }
        return tmp;
      }
      w1() {
        return new (UByte())(this.du());
      }
    }
    initMetadataForClass($, 'Iterator');
    IteratorClass = $;
  }
  return IteratorClass;
}
function UByteArray__contains_impl_njh19q($this, element) {
  var tmp = _UByteArray___get_storage__impl__d4kctt($this);
  // Inline function 'kotlin.UByte.toByte' call
  var tmp$ret$0 = _UByte___get_data__impl__jof9qr(element);
  return contains(tmp, tmp$ret$0);
}
function UByteArray__contains_impl_njh19q_0($this, element) {
  if (!(element instanceof UByte()))
    return false;
  return UByteArray__contains_impl_njh19q($this.eu_1, element instanceof UByte() ? element.zt_1 : THROW_CCE());
}
function UByteArray__containsAll_impl_v9s6dj($this, elements) {
  var tmp0 = isInterface(elements, Collection()) ? elements : THROW_CCE();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.s1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.u1();
    while (_iterator__ex2g4s.v1()) {
      var element = _iterator__ex2g4s.w1();
      var tmp_0;
      if (element instanceof UByte()) {
        var tmp_1 = _UByteArray___get_storage__impl__d4kctt($this);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = element.zt_1;
        var tmp$ret$1 = _UByte___get_data__impl__jof9qr(this_0);
        tmp_0 = contains(tmp_1, tmp$ret$1);
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function UByteArray__containsAll_impl_v9s6dj_0($this, elements) {
  return UByteArray__containsAll_impl_v9s6dj($this.eu_1, elements);
}
function UByteArray__isEmpty_impl_nbfqsa($this) {
  return _UByteArray___get_storage__impl__d4kctt($this).length === 0;
}
function UByteArray__toString_impl_ukpl97($this) {
  return 'UByteArray(storage=' + toString($this) + ')';
}
function UByteArray__hashCode_impl_ip8jx2($this) {
  return hashCode($this);
}
function UByteArray__equals_impl_roka4u($this, other) {
  if (!(other instanceof UByteArray()))
    return false;
  var tmp0_other_with_cast = other.eu_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var UByteArrayClass;
function UByteArray() {
  if (UByteArrayClass === VOID) {
    class $ {
      constructor(storage) {
        this.eu_1 = storage;
      }
      v2() {
        return _UByteArray___get_size__impl__h6pkdv(this.eu_1);
      }
      u1() {
        return UByteArray__iterator_impl_509y1p(this.eu_1);
      }
      fu(element) {
        return UByteArray__contains_impl_njh19q(this.eu_1, element);
      }
      y2(element) {
        return UByteArray__contains_impl_njh19q_0(this, element);
      }
      gu(elements) {
        return UByteArray__containsAll_impl_v9s6dj(this.eu_1, elements);
      }
      v4(elements) {
        return UByteArray__containsAll_impl_v9s6dj_0(this, elements);
      }
      s1() {
        return UByteArray__isEmpty_impl_nbfqsa(this.eu_1);
      }
      toString() {
        return UByteArray__toString_impl_ukpl97(this.eu_1);
      }
      hashCode() {
        return UByteArray__hashCode_impl_ip8jx2(this.eu_1);
      }
      equals(other) {
        return UByteArray__equals_impl_roka4u(this.eu_1, other);
      }
    }
    initMetadataForClass($, 'UByteArray', VOID, VOID, [Collection()]);
    UByteArrayClass = $;
  }
  return UByteArrayClass;
}
//region block: exports
export {
  _UByteArray___init__impl__ip4y9n as _UByteArray___init__impl__ip4y9n1pi3c8nr86gsm,
  _UByteArray___init__impl__ip4y9n_0 as _UByteArray___init__impl__ip4y9n2qcungomhrpkq,
  UByteArray__get_impl_t5f3hv as UByteArray__get_impl_t5f3hv2kcwqrq6tlagh,
  UByteArray__set_impl_jvcicn as UByteArray__set_impl_jvcicn1i6oj9yq6rlr5,
  _UByteArray___get_size__impl__h6pkdv as _UByteArray___get_size__impl__h6pkdv1042t8i4b34m4,
  _UByteArray___get_storage__impl__d4kctt as _UByteArray___get_storage__impl__d4kctti622i5rzxx5l,
  UByteArray as UByteArray2qu4d6gwssdf9,
};
//endregion

//# sourceMappingURL=UByteArray.mjs.map
